module.exports = __webpack_public_path__ + "img/1536818325.ac32d84b.jpg";